import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Layout, Modal, Row } from 'antd';

import PageHeader from "../../Components/PageHeader";
import { iconMapping } from "../../Configs/AppsConfig";
import ProspectForm from "./ProspectForm";
import ProspectTable from "./ProspectTable";
import PortfolioTransfer from "../Portfolio/PortfolioSelectors/PortfolioTransfer";
import { fetchUserFields, updateProspectPortfolios } from "../../Api/userApi";
import { fetchProspectsStats } from "../../Store/slices/prospects.slice";

const { Content } = Layout;

const Prospects = () => {
    const dispatch = useDispatch();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isPortfolioModalVisible, setIsPortfolioModalVisible] = useState(false);
    const [currentProspect, setCurrentProspect] = useState(undefined);

    // Optionally, use useSelector to access the prospects from the user state
    const prospects = useSelector(state => state.user.data?.prospects);
    const prospectIds = prospects?.map(prospect => prospect.user_id) ?? [];
    const prospectStats = useSelector(state => state.prospects.sessionStats); // assuming prospectSessions holds the stats

    console.log(prospectStats);
    const mergedProspects = prospects?.map(prospect => {
        const stats = prospectStats.find(stat => stat.uid === prospect.user_id) || {};
        return { ...prospect, ...stats };
    });

    // Function to show the modal
    const showModal = (prospect=undefined) => {
        setCurrentProspect(prospect);
        setIsModalVisible(true);
    };

    // Function to handle the modal close action
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const handleManagePortfolios = (prospect) => {
        setCurrentProspect(prospect);
        setIsPortfolioModalVisible(true);
    };

    // Inside the Prospects component

    const handlePortfolioSelectionChange = (selectedPortfolios) => {
        if (currentProspect) {
            // Update the current prospect's portfolios with the new selection
            setCurrentProspect({
                ...currentProspect,
                portfolios: selectedPortfolios
            });

            // Optionally, persist changes to the server or Redux store here
        }
    };


    // Use useEffect to fetch prospects data when the component mounts
    useEffect(() => {
        // Only fetch prospects if they haven't been loaded yet
        if (!prospects) {
            dispatch(fetchUserFields(['prospects']));
        }
        if (prospectIds.length > 0) {
            dispatch(fetchProspectsStats(prospectIds));
        }
    }, [dispatch, prospects]);
    const handleEditProspect = (prospect) => {
        showModal(prospect); // Opens the modal for editing

    };

    // Render the "Create Prospect" button with the onClick handler to show the modal
    const newButton = <Button type={'primary'} onClick={()=>showModal(undefined)}>Create Prospect</Button>;

    return (
        <Layout>
            <PageHeader title={'Prospects'} logoUrl={iconMapping.prospects} actions={[newButton]} />
            <Content>
                <Card title={'Prospects'}>
                    {prospects && <ProspectTable
                        prospects={mergedProspects}
                        onManagePortfolios={handleManagePortfolios}
                        onEditProspect={handleEditProspect}
                    />}
                </Card>
            </Content>
            <Modal
                title={currentProspect ? "Edit Prospect" : "Create New Prospect"}
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={null}
                destroyOnClose={true}
            >
                <ProspectForm prospect={currentProspect} />
            </Modal>

            <Modal
                title="Manage Portfolios"
                visible={isPortfolioModalVisible}
                onCancel={() => setIsPortfolioModalVisible(false)}
                onOk={() => {
                    // Assuming currentProspect has a property `userId` to identify the prospect
                    if (currentProspect && currentProspect.portfolios) {
                        dispatch(updateProspectPortfolios({
                            prospectUserId: currentProspect.userId,
                            portfolios: currentProspect.portfolios
                        }));
                    }
                    setIsPortfolioModalVisible(false);
                }}
                footer={[
                    <Button key="back" onClick={() => setIsPortfolioModalVisible(false)}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" onClick={() => {
                        if (currentProspect && currentProspect.portfolios) {
                            dispatch(updateProspectPortfolios({
                                prospectUserId: currentProspect.user_id,
                                portfolios: currentProspect.portfolios
                            }));
                        }
                        setIsPortfolioModalVisible(false);
                    }}>
                        Save
                    </Button>
                ]}
                destroyOnClose={true}
                width={800}
            >
                {currentProspect && <PortfolioTransfer
                    selectedIds={currentProspect?.portfolios?.map?.(portfolio => portfolio.id) ?? []}
                    onSelectionChange={handlePortfolioSelectionChange}/>
                }
            </Modal>

        </Layout>
    );
};

export default Prospects;
